<template>
  <JobsList :config="config" />
</template>

<script>
import JobsList from "../../components/JobsList/JobsList.vue";

export default {
  name: "app",
  components: {
    JobsList
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
